import { User } from '../../features/user-administration/models';

export interface UserState {
  users: User[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialState: UserState = {
  users: [],
  loading: false,
  loaded: false,
  error: null,
};
